import { nl2br } from "./Common.js";

const TbodyFacility = (props) => {
  const p = props["SJO"];
  const trSeats = p.saijo_CD==`1000`?``:`<tr>
    <th>ご利用人数</th>
    <td>～${p.SJO_seats_val}名</td>
  </tr>`;
  return `
  <tr>
    <th>住所</th>
    <td>${p.SJO_address01}${p.SJO_address02}${p.SJO_address03}</td>
  </tr>
  <tr>
    <th>電話番号</th>
    <td>0120-374-556</td>
  </tr>
  ${trSeats}
  <tr>
    <th>駐車場</th>
    <td>${p.SJO_parking_val}台</td>
  </tr>
  `;
}

const FacilityDrawings = (props) => {
  let HTML = ``;
  const count = Number(props["SJO"]["SJO_drawings"]);
  //ループ
  for(let i=1;i<=count;i++){
    const floorInfo = props["SJO"]["SJO_slug"]==`minamikashiwa`?`<p class="is-size-4 is-serif mb-0" style="position:absolute;top:-1em;left:0;">${i+1}F</p>`:
    props["SJO"]["SJO_slug"]==`minamigyotoku`?`<p class="is-size-4 is-serif mb-0" style="position:absolute;top:0;left:0;">${i}F</p>`:
    ``;
    const src = `/assets/image/drawing_${props["SJO"]["SJO_slug"]}0${i}.svg`;
    HTML += `<figure style="position:relative;">
      ${floorInfo}
      <img src="${src}">
      </figure>`;
  }
  return HTML;
}

const OutputImages = (SJO_slug,SEC_images,imgStart) =>{
  // 0埋めする関数
  const padZero = (num) => {
    return num.toString().padStart(2, '0');
  }

　const result = {
    "html":``,
    "imgStart":imgStart+Number(SEC_images)
  };

const htmls = {
  "0":(SJO_slug)=>{
    return ``;
  },
  "1":(SJO_slug)=>{
    const arr = Array.from({ length: Number(1)}, (v, i) => imgStart + i);
    const arr2 = arr.map(padZero);
    return `<figure class="image-2by3">
    <img src="/assets/image/${SJO_slug}.webp" alt="" class="src">
  </figure>`;

  },
  "2":(SJO_slug)=>{
    const arr = Array.from({ length: Number(2)}, (v, i) => imgStart + i);
    const arr2 = arr.map(padZero);
    return `<div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[0]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[1]}.webp" alt="" class="src">
    </figure>
    </div>`;

  },
  "3":(SJO_slug)=>{
    const arr = Array.from({ length: Number(3)}, (v, i) => imgStart + i);
    const arr2 = arr.map(padZero);
    return `
  <figure class="image-2by3">
    <img src="/assets/image/${SJO_slug}${arr2[0]}.webp" alt="" class="src">
  </figure>
  <div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[1]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[2]}.webp" alt="" class="src">
    </figure>
    </div>`;

  },
  "4":(SJO_slug)=>{
    const arr = Array.from({ length: Number(4)}, (v, i) => imgStart + i);
    const arr2 = arr.map(padZero);
    return `<div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[0]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[1]}.webp" alt="" class="src">
    </figure>
    </div>
    <div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[2]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[3]}.webp" alt="" class="src">
    </figure>
    </div>`;

  },
  "5":(SJO_slug)=>{
    const arr = Array.from({ length: Number(5)}, (v, i) => imgStart + i);
    const arr2 = arr.map(padZero);
    return `<figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[0]}.webp" alt="" class="src">
    </figure>
    <div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[1]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[2]}.webp" alt="" class="src">
    </figure>
    </div>
    <div class="grid-container">
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[3]}.webp" alt="" class="src">
    </figure>
    <figure class="image-2by3">
      <img src="/assets/image/${SJO_slug}${arr2[4]}.webp" alt="" class="src">
    </figure>
    </div>`;

  },

};
result["html"] = htmls[SEC_images](SJO_slug);




return result;
}

const FacilitySections = (props) =>{
  const p = props["SJO"];
  let imgStart = 1;
  return `${p["SECs"].map((v,k)=>{
    console.log(`SEC_mages`,v.SEC_images);
    let section = ``;

    if(v.SEC_images==`0`){
      return `<section class="hero is-light">
        <div class="hero-body">
          ${v.SEC_content}
        </div>
      </section>
      <section class="hero">
        <div class="hero-body has-text-centered">
          <h3 class="title is-size-6 is-serif mb-0">お問い合わせは月のあかりへ</h3>
          <div class="is-hidden-tablet mt-3"><a href="tel:0120-374-556"><span class="button is-primary-white is-arrow"><i class="fa-solid fa-phone is-size-5"></i><span class="is-size-5">&nbsp;&nbsp;0120-374-556</span></span></a></div>
          <p class="is-hidden-mobile is-serif is-size-2 my-0">0120-374-556</p>
        </div>
      </section>`;
    }else{
      const reverse = Number(v.section_NO)%2==0?``:`is-reverse-tablet`;
      const Images = OutputImages(p.SJO_slug,v.SEC_images,imgStart).html;
      imgStart = OutputImages(p.SJO_slug,v.SEC_images,imgStart).imgStart;
      section = `
      <section class="hero">
        <div class="columns is-gapless ${reverse}">
          <div class="column">
            ${Images}
          </div>
          <div class="column is-flex is-align-content-center is-flex-wrap-wrap">
            <section class="section">
              <div class="container">
                ${v.SEC_content}
              </div>
            </section>
          </div>
        </div>
      </section>`
    }
    return section}).join(``)}`;

}

const TagFacilities = (props) =>{
  console.log(`tag facility props`,props);
  if(props.SJO.saijo_CD=='1000'){
    return `<div><span class="tag">安置室使用料無料</span></div>`;
  }
  if(props.SJO.SJO_category!=`05`){
    return ``;
  }
  return `<div><span class="tag">式場使用料無料</span></div><div><span class="tag">安置室使用料無料</span></div>`;

}

export const Facility = {
  props:{},
  async init(){
    if(!document.querySelector(`input[name="SJO_slug"]`))return;
    console.log(`Facility init!`);
    await this.getRequest();
    console.log(`facility props`,this.props);
    const dataNames = document.querySelectorAll(`[data-name]`);
    dataNames.forEach(v=>{
      const key = v.dataset.name;
      v.innerHTML = nl2br(this.props["SJO"][key]);
    })

    const tbodyFacility = document.getElementById('tbody-facility');
    tbodyFacility?tbodyFacility.innerHTML = TbodyFacility(this.props):``;

    const facilityDrawings = document.getElementById('facility-drawings');
    facilityDrawings?facilityDrawings.innerHTML = FacilityDrawings(this.props):``;
    const facilitySections = document.getElementById('facility-sections');
    facilitySections?facilitySections.innerHTML = FacilitySections(this.props):``;
    const tagFacilities = document.getElementById('tag-facilities');
    tagFacilities?tagFacilities.innerHTML = TagFacilities(this.props):``;
    const iframe = document.querySelector(`.googlemap`);
    iframe?iframe.setAttribute(`src`,this.props["SJO"].SJO_googlemap):``;

  },
  async getRequest(){
    const SJO_slug = document.querySelector(`input[name="SJO_slug"]`).value;
    const url = `https://tokatsu-system.com/api/v1.1/tokatsu/saijo/${SJO_slug}`;
    const response = await axios.get(url,{})
    this.props = {"SJO":response.data.res};


  },
}